<template>
    <Dialog :open="open" :title="$t('account.createNewSubscription')" @close="$emit('close')">
        <v-form v-model="valid">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            v-model="subscription.Name"
                            :rules="[$validations.required]"
                            required>
                        <template v-slot:label>
                            {{ $t('authentication.subscriptionName') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-0">
                <v-col class="pt-0" cols="12">
                    <v-autocomplete
                            v-model="subscription.Timezone"
                            :items="timezones"
                            :rules="[$validations.required]"
                            item-text="DisplayName"
                            item-value="Id">
                        <template v-slot:label>
                            {{ $t('settings.timezone') }}<sup>*</sup>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="sendInvitation">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "NewSubscriptionDialog",
  components: {Dialog},
  mounted() {
    this.initTimezones();
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      subscription: {
        Name: '',
        subscriptionID: 1,
        Timezone: '',
      },
      timezones: [],
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    }
  },
  methods: {
    sendInvitation() {
      const url = this.$store.getters.organization();
      this.loading = true;
      this.axios.post(url, this.subscription).then(() => {
        this.$emit('close', true);
        this.subscriptionName = '';
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.subscriptionWasCreated'),
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    initTimezones() {
      const url = this.$store.getters.getUrl('timezones');
      this.axios.get(url).then(({data}) => {
        this.timezones = data.Result;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const country = tz.substring(tz.indexOf('/') + 1);
        const timezone = this.timezones.filter((timezone) => timezone.DisplayName.includes(country));
        if (timezone.length) {
          this.subscription.Timezone = timezone[0].Id;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>